/*
 * @Author: your name
 * @Date: 2021-10-04 17:25:50
 * @LastEditTime: 2021-10-04 17:25:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\plugin\eventBus\index.js
 */
import Vue from 'vue'
const eventBus = new Vue()
export { eventBus }
